import { FormattedDateTime, LoadingSkeleton } from "@edgetier/client-components";
import { FunctionComponent, memo } from "react";
import { IProps } from "./interaction-summary.types";
import "./interaction-summary.scss";

/**
 * Create an interaction summary/title.
 * @param props.activeTranslation   Translation for interaction content.
 * @param props.contentCleaned      Interaction content.
 * @param props.startDateTime       Start time of the interaction.
 * @param props.subject             Optional subject line.
 * @returns
 */
const InteractionSummary: FunctionComponent<IProps> = ({
    contentCleaned,
    subject,
    startDateTime,
    activeTranslation,
}) => (
    <div className="interaction-summary">
        {typeof startDateTime !== "undefined" && (
            <>
                <FormattedDateTime colourTime={false} dateTime={startDateTime} />
                &ndash;
            </>
        )}
        {typeof activeTranslation !== "undefined" ? (
            <>
                {activeTranslation.isLoading ? (
                    <LoadingSkeleton />
                ) : (
                    <span className="interaction-summary__text">
                        {activeTranslation.isTranslated && activeTranslation.translatedText.trim().length > 0
                            ? activeTranslation.translatedText
                            : subject ?? contentCleaned}
                    </span>
                )}
            </>
        ) : (
            <span className="interaction-summary__text">{subject ?? contentCleaned}</span>
        )}
    </div>
);

export default memo(InteractionSummary);
